import QuickTour from './QuickTour';

const path = '/dashboard/quick-tour';

const routes = [
  {
    name: 'QuickTour',
    path: `${path}`,
    icon: '',
    component: QuickTour,
    exact: true,
  },
];

export const redirects = [
  {
    from: `${path}`,
    to: `${path}`,
  },
  {
    from: `${path}/*`,
    to: `${path}`,
  },
];

export default routes;
